// extracted by mini-css-extract-plugin
module.exports = {"section":"_5969ba20","noArticles":"_fd9f8a1f","content":"_f6a40940","article":"_8cdd7dcd"};